import React from "react";
import { Col, Row } from "react-bootstrap";
import { FaCircleXmark } from "react-icons/fa6";
import ModalContainer from "../ModalContainer";
import { Description, SubTitle } from "../CustomComponents";
import cssStyles from "./styles/viewPostModal.module.scss";

import { formatedDate } from "../../constants";
import { uniqueId } from "lodash";
import ImageWithPlaceholder from "../CustomComponents/ImageWithPlaceholder";
import LazyLoad from "react-lazy-load";

const ViewEventModal = ({ handleViewModalClose, data }) => {
  return (
    <div>
      <ModalContainer handleClose={handleViewModalClose}>
        <div className={cssStyles.modalContainer}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-semibold m-0 black-text">View Class</p>
            <span className="bg-white bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                role="button"
                onClick={handleViewModalClose}
                style={{ cursor: "pointer", color: "black" }}
              />
            </span>
          </div>

          <Row className="w-100 h-100">
            <Col md={6} sm={12}>
              {/* <LazyLoad
                key={uniqueId()}
                style={{
                  width: "100%",
                  height: "420px",
                  maxHeight: "420px",
                  objectFit: "contain",
                  backgroundColor: "black",
                }}
                threshold={0.95}
                debounce={500}
                onContentVisible={() => {
                  // console.log("loaded!");
                }}
              > */}
                {/* <ImageWithPlaceholder
                  src={data.image_url}
                  placeholder={"images/placeholder.webp"}
                  alt="training"
                  className="rounded-3"
                  style={{
                    maxHeight: "420px",
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    backgroundColor: "black",
                  }}
                /> */}
              {/* </LazyLoad> */}
              <img
                className={`${cssStyles.workoutImage} rounded`}
                src={data.image_url}
                alt="Event"
                loading="lazy"
                width="100%"
                style={{
                  maxHeight: "420px",
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  backgroundColor: "black",
                }}
              />
            </Col>

            <Col md={6} sm={12} className="mt-3">
              <div className="d-flex flex-column w-100 h-100">
                <SubTitle classes="fs-5 black-text mb-2" text={data.title} />
                <Description
                  classes="my-1 black-text"
                  text={`Start Date: ${formatedDate(data.start_at)}`}
                />
                <Description
                  classes="my-1 text-black-50"
                  text={`Location: ${data.location}`}
                />
                <Description
                  classes="my-1 text-black-50"
                  text={`Event Name: ${data.event_name}`}
                />

                <hr />

                <SubTitle
                  classes="lc-1 fs-6 black-text mt-2"
                  text="Host Information"
                />
                <Description
                  classes="my-1 text-black-50"
                  text={`Name: ${data.host_name}`}
                />
                <Description
                  classes="my-1 text-black-50"
                  text={`Designation: ${data.host_designation}`}
                />
                <Description
                  classes="my-1 text-black-50"
                  text={`Experience: ${data.host_experience} years`}
                />

                <hr />

                <Description
                  classes="my-2 black-text"
                  text={`Description: ${data.description}`}
                />
              </div>
            </Col>
          </Row>
        </div>
      </ModalContainer>
    </div>
  );
};

export default ViewEventModal;
